export const STANDARD_PACKAGE_TYPE = "standard";
export const B2B_PACKAGE_TYPE = "B2B";
export const DOCUMENTS_PACKAGE_TYPE = "documents";
export const C2C_PACKAGE_TYPE = "C2C";

export const COURIER_DELIVERY_TYPE = "courier";
export const VISIT_OFFICE_DELIVERY_TYPE = "visit office";
export const LOCAL_CARGO_DELIVERY_TYPE = "local cargo";

export const INDIVIDUAL_USER_TYPE = "individual";
export const LEGAL_USER_TYPE = "legal";

export const SENDER_TOWN_DOES_NOT_HAVE_DISTRICT = "sender town does not have district";

export const i18nLangs = {
    RU: "ru",
    TR: "tr",
    EN: "en",
}

export const deliveryTypes = [
    {
        value: COURIER_DELIVERY_TYPE,
        text: {
            ru: "Курьером из дома",
            tr: "Adresten kurye alımı",
        },
    },
    {
        value: VISIT_OFFICE_DELIVERY_TYPE,
        text: {
            ru: "Посещение офиса",
            tr: "Ofis ziyareti",
        },
    },
    {
        value: LOCAL_CARGO_DELIVERY_TYPE,
        text: {
            ru: "Через локальный карго",
            tr: "Kargo aracılığıyla",
        },
    },
];

export const deliverySpeeds = {
    standard: {
        value: "standard",
    },
    express: {
        value: "express",
    },
};

export const packageTypes = [
    {
        value: STANDARD_PACKAGE_TYPE,
        text: {
            ru: "Товары из интернет-магазинов",
            tr: "Online-mağaza ürünleri",
        },
    },
    {
        value: DOCUMENTS_PACKAGE_TYPE,
        text: {
            ru: "Документы",
            tr: "Evrak",
        },
    },
    {
        value: B2B_PACKAGE_TYPE,
        text: {
            ru: "Образцы",
            tr: "Numune",
        },
    },
    {
        value: C2C_PACKAGE_TYPE,
        text: {
            ru: "C2C",
            tr: "C2C",
        },
    },
];

export const CARD_ONLINE_PAYMENT_TYPE = "card (online)";

export const paymentTypes = [
    {
        value: "cash",
        text: {
            ru: "Наличными",
            tr: "Nakit",
        },
    },
    {
        value: CARD_ONLINE_PAYMENT_TYPE,
        text: {
            ru: "Картой онлайн",
            tr: "Kart online",
        },
    },
    {
        value: "card (POS)",
        text: {
            ru: "Картой POS-терминалом",
            tr: "Kart POS ödeme",
        },
    },
    // {
    //     value: "transfer",
    //     text: {
    //         ru: "Переводом",
    //         tr: "Havale"
    //     }
    // },
];

export const receivingRegions = [
    {
        text: "region1",
        value: 1,
    },
    {
        text: "region2",
        value: 2,
    },
    {
        text: "region3",
        value: 3,
    },
    {
        text: "region4",
        value: 4,
    },
    {
        text: "region5",
        value: 5,
    },
    {
        text: "region6",
        value: 6,
    },
    {
        text: "region7",
        value: 7,
    },
    {
        text: "region8",
        value: 8,
    },
    {
        text: "region9",
        value: 9,
    },
    {
        text: "region10",
        value: 10,
    },
    {
        text: "region11",
        value: 11,
    },
    {
        text: "region12",
        value: 12,
    },
    {
        text: "region13",
        value: 13,
    },
    {
        text: "region14",
        value: 14,
    },
    {
        text: "russia1",
        value: 32,
    },
    {
        text: "russia2",
        value: 33,
    },
    {
        text: "russia3",
        value: 34,
    },
    {
        text: "russia4",
        value: 35,
    },
    {
        text: "russia5",
        value: 36,
    },
    {
        text: "moldova1",
        value: 18,
    },
    {
        text: "moldova2",
        value: 19,
    },
    {
        text: "moldova3",
        value: 20,
    },
    {
        text: "moldova4",
        value: 21,
    },
    {
        text: "ukraine1",
        value: 22,
    },
    {
        text: "ukraine2",
        value: 23,
    },
    {
        text: "kazakhstan1",
        value: 24,
    },
    {
        text: "kazakhstan2",
        value: 25,
    },
    {
        text: "kazakhstan3",
        value: 26,
    },
    {
        text: "kazakhstan4",
        value: 27,
    },
    {
        text: "kazakhstan5",
        value: 28,
    },
    {
        text: "kazakhstan6",
        value: 29,
    },
    {
        text: "kazakhstan7",
        value: 30,
    },
    {
        text: "belarussia1",
        value: 31,
    }
];

export const paymentSystems = {
    moka: {
        value: "moka",
        text: "Moka",
    },
    tinkoff: {
        value: "tinkoff",
        text: "Tinkoff",
    },
};

export const countryCodes = [
    {
        value: "TR",
        text: "TR",
    },
    {
        value: "AD",
        text: "AD",
    },
    {
        value: "AE",
        text: "AE",
    },
    {
        value: "AF",
        text: "AF",
    },
    {
        value: "AG",
        text: "AG",
    },
    {
        value: "AI",
        text: "AI",
    },
    {
        value: "AL",
        text: "AL",
    },
    {
        value: "AM",
        text: "AM",
    },
    {
        value: "AO",
        text: "AO",
    },
    {
        value: "AR",
        text: "AR",
    },
    {
        value: "AS",
        text: "AS",
    },
    {
        value: "AT",
        text: "AT",
    },
    {
        value: "AU",
        text: "AU",
    },
    {
        value: "AW",
        text: "AW",
    },
    {
        value: "AZ",
        text: "AZ",
    },
    {
        value: "BA",
        text: "BA",
    },
    {
        value: "BB",
        text: "BB",
    },
    {
        value: "BD",
        text: "BD",
    },
    {
        value: "BE",
        text: "BE",
    },
    {
        value: "BF",
        text: "BF",
    },
    {
        value: "BG",
        text: "BG",
    },
    {
        value: "BH",
        text: "BH",
    },
    {
        value: "BI",
        text: "BI",
    },
    {
        value: "BJ",
        text: "BJ",
    },
    {
        value: "BL",
        text: "BL",
    },
    {
        value: "BM",
        text: "BM",
    },
    {
        value: "BN",
        text: "BN",
    },
    {
        value: "BO",
        text: "BO",
    },
    {
        value: "BQ",
        text: "BQ",
    },
    {
        value: "BR",
        text: "BR",
    },
    {
        value: "BS",
        text: "BS",
    },
    {
        value: "BT",
        text: "BT",
    },
    {
        value: "BW",
        text: "BW",
    },
    {
        value: "BY",
        text: "BY",
    },
    {
        value: "BZ",
        text: "BZ",
    },
    {
        value: "CA",
        text: "CA",
    },
    {
        value: "CC",
        text: "CC",
    },
    {
        value: "CD",
        text: "CD",
    },
    {
        value: "CF",
        text: "CF",
    },
    {
        value: "CG",
        text: "CG",
    },
    {
        value: "CH",
        text: "CH",
    },
    {
        value: "CI",
        text: "CI",
    },
    {
        value: "CK",
        text: "CK",
    },
    {
        value: "CL",
        text: "CL",
    },
    {
        value: "CM",
        text: "CM",
    },
    {
        value: "CN",
        text: "CN",
    },
    {
        value: "CO",
        text: "CO",
    },
    {
        value: "CR",
        text: "CR",
    },
    {
        value: "CU",
        text: "CU",
    },
    {
        value: "CV",
        text: "CV",
    },
    {
        value: "CW",
        text: "CW",
    },
    {
        value: "CX",
        text: "CX",
    },
    {
        value: "CY",
        text: "CY",
    },
    {
        value: "CZ",
        text: "CZ",
    },
    {
        value: "DE",
        text: "DE",
    },
    {
        value: "DJ",
        text: "DJ",
    },
    {
        value: "DK",
        text: "DK",
    },
    {
        value: "DM",
        text: "DM",
    },
    {
        value: "DO",
        text: "DO",
    },
    {
        value: "DZ",
        text: "DZ",
    },
    {
        value: "EC",
        text: "EC",
    },
    {
        value: "EE",
        text: "EE",
    },
    {
        value: "EG",
        text: "EG",
    },
    {
        value: "ER",
        text: "ER",
    },
    {
        value: "ES",
        text: "ES",
    },
    {
        value: "ET",
        text: "ET",
    },
    {
        value: "FI",
        text: "FI",
    },
    {
        value: "FJ",
        text: "FJ",
    },
    {
        value: "FM",
        text: "FM",
    },
    {
        value: "FO",
        text: "FO",
    },
    {
        value: "FR",
        text: "FR",
    },
    {
        value: "GA",
        text: "GA",
    },
    {
        value: "GB",
        text: "GB",
    },
    {
        value: "GD",
        text: "GD",
    },
    {
        value: "GE",
        text: "GE",
    },
    {
        value: "GF",
        text: "GF",
    },
    {
        value: "GH",
        text: "GH",
    },
    {
        value: "GI",
        text: "GI",
    },
    {
        value: "GL",
        text: "GL",
    },
    {
        value: "GM",
        text: "GM",
    },
    {
        value: "GN",
        text: "GN",
    },
    {
        value: "GP",
        text: "GP",
    },
    {
        value: "GQ",
        text: "GQ",
    },
    {
        value: "GR",
        text: "GR",
    },
    {
        value: "GT",
        text: "GT",
    },
    {
        value: "GU",
        text: "GU",
    },
    {
        value: "GW",
        text: "GW",
    },
    {
        value: "GY",
        text: "GY",
    },
    {
        value: "HK",
        text: "HK",
    },
    {
        value: "HN",
        text: "HN",
    },
    {
        value: "HR",
        text: "HR",
    },
    {
        value: "HT",
        text: "HT",
    },
    {
        value: "HU",
        text: "HU",
    },
    {
        value: "ID",
        text: "ID",
    },
    {
        value: "IE",
        text: "IE",
    },
    {
        value: "IL",
        text: "IL",
    },
    {
        value: "IN",
        text: "IN",
    },
    {
        value: "IQ",
        text: "IQ",
    },
    {
        value: "IS",
        text: "IS",
    },
    {
        value: "IT",
        text: "IT",
    },
    {
        value: "JM",
        text: "JM",
    },
    {
        value: "JO",
        text: "JO",
    },
    {
        value: "JP",
        text: "JP",
    },
    {
        value: "KE",
        text: "KE",
    },
    {
        value: "KG",
        text: "KG",
    },
    {
        value: "KH",
        text: "KH",
    },
    {
        value: "KI",
        text: "KI",
    },
    {
        value: "KN",
        text: "KN",
    },
    {
        value: "KR",
        text: "KR",
    },
    {
        value: "KW",
        text: "KW",
    },
    {
        value: "KY",
        text: "KY",
    },
    {
        value: "KZ",
        text: "KZ",
    },
    {
        value: "LA",
        text: "LA",
    },
    {
        value: "LB",
        text: "LB",
    },
    {
        value: "LC",
        text: "LC",
    },
    {
        value: "LI",
        text: "LI",
    },
    {
        value: "LK",
        text: "LK",
    },
    {
        value: "LR",
        text: "LR",
    },
    {
        value: "LS",
        text: "LS",
    },
    {
        value: "LT",
        text: "LT",
    },
    {
        value: "LU",
        text: "LU",
    },
    {
        value: "LV",
        text: "LV",
    },
    {
        value: "LY",
        text: "LY",
    },
    {
        value: "MA",
        text: "MA",
    },
    {
        value: "MC",
        text: "MC",
    },
    {
        value: "MD",
        text: "MD",
    },
    {
        value: "ME",
        text: "ME",
    },
    {
        value: "MF",
        text: "MF",
    },
    {
        value: "MG",
        text: "MG",
    },
    {
        value: "MH",
        text: "MH",
    },
    {
        value: "MK",
        text: "MK",
    },
    {
        value: "ML",
        text: "ML",
    },
    {
        value: "MM",
        text: "MM",
    },
    {
        value: "MN",
        text: "MN",
    },
    {
        value: "MO",
        text: "MO",
    },
    {
        value: "MP",
        text: "MP",
    },
    {
        value: "MQ",
        text: "MQ",
    },
    {
        value: "MR",
        text: "MR",
    },
    {
        value: "MS",
        text: "MS",
    },
    {
        value: "MT",
        text: "MT",
    },
    {
        value: "MU",
        text: "MU",
    },
    {
        value: "MV",
        text: "MV",
    },
    {
        value: "MW",
        text: "MW",
    },
    {
        value: "MX",
        text: "MX",
    },
    {
        value: "MY",
        text: "MY",
    },
    {
        value: "MZ",
        text: "MZ",
    },
    {
        value: "NA",
        text: "NA",
    },
    {
        value: "NC",
        text: "NC",
    },
    {
        value: "NE",
        text: "NE",
    },
    {
        value: "NF",
        text: "NF",
    },
    {
        value: "NG",
        text: "NG",
    },
    {
        value: "NI",
        text: "NI",
    },
    {
        value: "NL",
        text: "NL",
    },
    {
        value: "NO",
        text: "NO",
    },
    {
        value: "NP",
        text: "NP",
    },
    {
        value: "NR",
        text: "NR",
    },
    {
        value: "NZ",
        text: "NZ",
    },
    {
        value: "OM",
        text: "OM",
    },
    {
        value: "PA",
        text: "PA",
    },
    {
        value: "PE",
        text: "PE",
    },
    {
        value: "PF",
        text: "PF",
    },
    {
        value: "PG",
        text: "PG",
    },
    {
        value: "PH",
        text: "PH",
    },
    {
        value: "PK",
        text: "PK",
    },
    {
        value: "PL",
        text: "PL",
    },
    {
        value: "PM",
        text: "PM",
    },
    {
        value: "PR",
        text: "PR",
    },
    {
        value: "PS",
        text: "PS",
    },
    {
        value: "PT",
        text: "PT",
    },
    {
        value: "PW",
        text: "PW",
    },
    {
        value: "PY",
        text: "PY",
    },
    {
        value: "QA",
        text: "QA",
    },
    {
        value: "RE",
        text: "RE",
    },
    {
        value: "RO",
        text: "RO",
    },
    {
        value: "RS",
        text: "RS",
    },
    {
        value: "RU",
        text: "RU",
    },
    {
        value: "RW",
        text: "RW",
    },
    {
        value: "SA",
        text: "SA",
    },
    {
        value: "SB",
        text: "SB",
    },
    {
        value: "SC",
        text: "SC",
    },
    {
        value: "SE",
        text: "SE",
    },
    {
        value: "SG",
        text: "SG",
    },
    {
        value: "SI",
        text: "SI",
    },
    {
        value: "SK",
        text: "SK",
    },
    {
        value: "SL",
        text: "SL",
    },
    {
        value: "SM",
        text: "SM",
    },
    {
        value: "SN",
        text: "SN",
    },
    {
        value: "SR",
        text: "SR",
    },
    {
        value: "ST",
        text: "ST",
    },
    {
        value: "SV",
        text: "SV",
    },
    {
        value: "SX",
        text: "SX",
    },
    {
        value: "SZ",
        text: "SZ",
    },
    {
        value: "TC",
        text: "TC",
    },
    {
        value: "TD",
        text: "TD",
    },
    {
        value: "TG",
        text: "TG",
    },
    {
        value: "TH",
        text: "TH",
    },
    {
        value: "TJ",
        text: "TJ",
    },
    {
        value: "TL",
        text: "TL",
    },
    {
        value: "TM",
        text: "TM",
    },
    {
        value: "TN",
        text: "TN",
    },
    {
        value: "TO",
        text: "TO",
    },
    {
        value: "TR",
        text: "TR",
    },
    {
        value: "TT",
        text: "TT",
    },
    {
        value: "TV",
        text: "TV",
    },
    {
        value: "TW",
        text: "TW",
    },
    {
        value: "TZ",
        text: "TZ",
    },
    {
        value: "UA",
        text: "UA",
    },
    {
        value: "UG",
        text: "UG",
    },
    {
        value: "US",
        text: "US",
    },
    {
        value: "UY",
        text: "UY",
    },
    {
        value: "UZ",
        text: "UZ",
    },
    {
        value: "VA",
        text: "VA",
    },
    {
        value: "VC",
        text: "VC",
    },
    {
        value: "VE",
        text: "VE",
    },
    {
        value: "VG",
        text: "VG",
    },
    {
        value: "VI",
        text: "VI",
    },
    {
        value: "VN",
        text: "VN",
    },
    {
        value: "VU",
        text: "VU",
    },
    {
        value: "WF",
        text: "WF",
    },
    {
        value: "WS",
        text: "WS",
    },
    {
        value: "YK",
        text: "YK",
    },
    {
        value: "YT",
        text: "YT",
    },
    {
        value: "ZA",
        text: "ZA",
    },
    {
        value: "ZM",
        text: "ZM",
    },
    {
        value: "ZW",
        text: "ZW",
    },
];

export const senderCities = [
    {
        value: "01",
        text: "Adana",
        hasExpressPickup: false,
        towns: [
            {
                value: "1",
                text: "CEYHAN",
            },
            {
                value: "2",
                text: "ÇUKUROVA",
            },
            {
                value: "3",
                text: "İMAMOĞLU",
            },
            {
                value: "4",
                text: "KOZAN",
            },
            {
                value: "5",
                text: "SARIÇAM",
            },
            {
                value: "6",
                text: "SEYHAN",
            },
            {
                value: "7",
                text: "YÜREĞİR",
            },
        ],
    },
    {
        value: "02",
        text: "Adıyaman",
        hasExpressPickup: false,
        towns: [
            {
                value: "8",
                text: "MERKEZ",
            },
            {
                value: "9",
                text: "BESNİ",
            },
            {
                value: "10",
                text: "ÇELİKHAN",
            },
            {
                value: "11",
                text: "GÖLBAŞI",
            },
            {
                value: "12",
                text: "KAHTA",
            },
            {
                value: "13",
                text: "TUT",
            },
        ],
    },
    {
        value: "03",
        text: "Afyon",
        hasExpressPickup: false,
        towns: [
            {
                value: "14",
                text: "MERKEZ",
            },
            {
                value: "15",
                text: "İSCEHİSAR",
            },
            {
                value: "16",
                text: "ŞUHUT",
            },
            {
                value: "17",
                text: "SANDIKLI",
            },
            {
                value: "18",
                text: "BOLVADİN",
            },
            {
                value: "19",
                text: "ÇAY",
            },
            {
                value: "20",
                text: "ÇOBANLAR",
            },
            {
                value: "21",
                text: "DİNAR",
            },
            {
                value: "22",
                text: "İHSANİYE",
            },
        ],
    },
    {
        value: "04",
        text: "Ağrı",
        hasExpressPickup: false,
        towns: [],
    },
    {
        value: "68",
        text: "Aksaray",
        hasExpressPickup: false,
        towns: [
            {
                value: "23",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "05",
        text: "Amasya",
        hasExpressPickup: false,
        towns: [
            {
                value: "24",
                text: "GÜMÜŞHACIKÖY",
            },
            {
                value: "25",
                text: "SULUOVA",
            },
        ],
    },
    {
        value: "06",
        text: "Ankara",
        hasExpressPickup: false,
        towns: [
            {
                value: "26",
                text: "KEÇİÖREN",
            },
            {
                value: "27",
                text: "SİNCAN",
            },
            {
                value: "28",
                text: "MAMAK",
            },
            {
                value: "29",
                text: "PURSAKLAR",
            },
            {
                value: "30",
                text: "GÖLBAŞI",
            },
            {
                value: "31",
                text: "KAHRAMANKAZAN",
            },
            {
                value: "32",
                text: "BEYPAZARI",
            },
            {
                value: "33",
                text: "ELMADAĞ",
            },
            {
                value: "34",
                text: "AKYURT",
            },
            {
                value: "35",
                text: "YENİMAHALLE",
            },
            {
                value: "36",
                text: "ÇANKAYA",
            },
            {
                value: "37",
                text: "ETİMESGUT",
            },
            {
                value: "38",
                text: "ALTINDAĞ",
            },
            {
                value: "39",
                text: "ÇUBUK",
            },
        ],
    },
    {
        value: "07",
        text: "Antalya",
        hasExpressPickup: true,
        towns: [
            {
                value: "40",
                text: "AKSU",
            },
            {
                value: "41",
                text: "ALANYA",
            },
            {
                value: "42",
                text: "DEMRE",
            },
            {
                value: "43",
                text: "DÖŞEMEALTI",
            },
            {
                value: "44",
                text: "FİNİKE",
            },
            {
                value: "45",
                text: "GAZİPAŞA",
            },
            {
                value: "46",
                text: "KEMER",
            },
            {
                value: "47",
                text: "KEPEZ",
            },
            {
                value: "48",
                text: "KONYAALTI",
            },
            {
                value: "49",
                text: "KUMLUCA",
            },
            {
                value: "50",
                text: "MANAVGAT",
            },
            {
                value: "51",
                text: "MURATPAŞA",
            },
            {
                value: "52",
                text: "SERİK",
            },
        ],
    },
    {
        value: "75",
        text: "Ardahan",
        hasExpressPickup: false,
        towns: [
            {
                value: "53",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "08",
        text: "Artvin",
        hasExpressPickup: false,
        towns: [
            {
                value: "54",
                text: "MERKEZ",
            },
            {
                value: "55",
                text: "ARHAVİ",
            },
            {
                value: "56",
                text: "BORÇKA",
            },
            {
                value: "57",
                text: "HOPA",
            },
            {
                value: "58",
                text: "KEMALPAŞA",
            },
        ],
    },
    {
        value: "09",
        text: "Aydın",
        hasExpressPickup: false,
        towns: [
            {
                value: "59",
                text: "DİDİM",
            },
            {
                value: "60",
                text: "KUŞADASI",
            },
            {
                value: "61",
                text: "SÖKE",
            },
            {
                value: "62",
                text: "EFELER",
            },
            {
                value: "63",
                text: "İNCİRLİOVA",
            },
            {
                value: "64",
                text: "KÖŞK",
            },
            {
                value: "65",
                text: "ÇİNE",
            },
            {
                value: "66",
                text: "GERMENCİK",
            },
            {
                value: "67",
                text: "NAZİLLİ",
            },
            {
                value: "68",
                text: "SULTANHİSAR",
            },
            {
                value: "69",
                text: "YENİPAZAR",
            },
        ],
    },
    {
        value: "10",
        text: "Balıkesir",
        hasExpressPickup: false,
        towns: [
            {
                value: "70",
                text: "ALTIEYLÜL",
            },
            {
                value: "71",
                text: "AYVALIK",
            },
            {
                value: "72",
                text: "BANDIRMA",
            },
            {
                value: "73",
                text: "BURHANİYE",
            },
            {
                value: "74",
                text: "EDREMİT",
            },
            {
                value: "75",
                text: "ERDEK",
            },
            {
                value: "76",
                text: "GÖNEN",
            },
            {
                value: "77",
                text: "GÖMEÇ",
            },
            {
                value: "78",
                text: "KARESİ",
            },
        ],
    },
    {
        value: "74",
        text: "Bartın",
        hasExpressPickup: false,
        towns: [
            {
                value: "79",
                text: "AMASRA",
            },
            {
                value: "80",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "72",
        text: "Batman",
        hasExpressPickup: false,
        towns: [
            {
                value: "81",
                text: "BEŞİRİ",
            },
            {
                value: "82",
                text: "GERCÜŞ",
            },
            {
                value: "83",
                text: "HASANKEYF",
            },
            {
                value: "84",
                text: "KOZLUK",
            },
            {
                value: "85",
                text: "MERKEZ",
            },
            {
                value: "86",
                text: "SASON",
            },
        ],
    },
    {
        value: "69",
        text: "Bayburt",
        hasExpressPickup: false,
        towns: [
            {
                value: "87",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "11",
        text: "Bilecik",
        hasExpressPickup: false,
        towns: [
            {
                value: "88",
                text: "MERKEZ",
            },
            {
                value: "89",
                text: "BOZÜYÜK",
            },
        ],
    },
    {
        value: "12",
        text: "Bingöl",
        hasExpressPickup: false,
        towns: [
            {
                value: "90",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "13",
        text: "Bitlis",
        hasExpressPickup: false,
        towns: [
            {
                value: "91",
                text: "AHLAT",
            },
            {
                value: "92",
                text: "ADİLCEVAZ",
            },
            {
                value: "93",
                text: "GÜROYMAK",
            },
            {
                value: "94",
                text: "HİZAN",
            },
            {
                value: "95",
                text: "MERKEZ",
            },
            {
                value: "96",
                text: "TATVAN",
            },
        ],
    },
    {
        value: "14",
        text: "Bolu",
        hasExpressPickup: false,
        towns: [
            {
                value: "97",
                text: "GEREDE",
            },
            {
                value: "98",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "15",
        text: "Burdur",
        hasExpressPickup: false,
        towns: [
            {
                value: "99",
                text: "MERKEZ",
            },
            {
                value: "100",
                text: "BUCAK",
            },
            {
                value: "101",
                text: "ÇELTİKÇİ",
            },
        ],
    },
    {
        value: "16",
        text: "Bursa",
        hasExpressPickup: false,
        towns: [
            {
                value: "102",
                text: "GEMLİK",
            },
            {
                value: "103",
                text: "İNEGÖL",
            },
            {
                value: "104",
                text: "KARACABEY",
            },
            {
                value: "105",
                text: "MUDANYA",
            },
            {
                value: "106",
                text: "MUSTAFAKEMALPAŞA",
            },
            {
                value: "107",
                text: "YENİŞEHİR",
            },
            {
                value: "108",
                text: "GÜRSU",
            },
            {
                value: "109",
                text: "ORHANGAZİ",
            },
            {
                value: "110",
                text: "NİLÜFER",
            },
            {
                value: "111",
                text: "YILDIRIM",
            },
            {
                value: "112",
                text: "İZNİK",
            },
            {
                value: "113",
                text: "OSMANGAZİ",
            },
            {
                value: "114",
                text: "KESTEL",
            },
        ],
    },
    {
        value: "17",
        text: "Çanakkale",
        hasExpressPickup: false,
        towns: [
            {
                value: "115",
                text: "MERKEZ",
            },
            {
                value: "116",
                text: "BİGA",
            },
            {
                value: "117",
                text: "AYVACIK",
            },
            {
                value: "118",
                text: "ÇAN",
            },
            {
                value: "119",
                text: "EZİNE",
            },
            {
                value: "120",
                text: "BAYRAMİÇ",
            },
            {
                value: "121",
                text: "GELİBOLU",
            },
            {
                value: "122",
                text: "LAPSEKİ",
            },
            {
                value: "123",
                text: "YENİCE",
            },
        ],
    },
    {
        value: "18",
        text: "Çankırı",
        hasExpressPickup: false,
        towns: [
            {
                value: "124",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "19",
        text: "Çorum",
        hasExpressPickup: false,
        towns: [
            {
                value: "125",
                text: "MERKEZ",
            },
            {
                value: "126",
                text: "ALACA",
            },
            {
                value: "127",
                text: "OSMANCIK",
            },
            {
                value: "128",
                text: "SUNGURLU",
            },
        ],
    },
    {
        value: "20",
        text: "Denizli",
        hasExpressPickup: false,
        towns: [
            {
                value: "129",
                text: "ACIPAYAM",
            },
            {
                value: "130",
                text: "BULDAN",
            },
            {
                value: "131",
                text: "ÇİVRİL",
            },
            {
                value: "132",
                text: "HONAZ",
            },
            {
                value: "133",
                text: "MERKEZEFENDİ",
            },
            {
                value: "134",
                text: "PAMUKKALE",
            },
            {
                value: "135",
                text: "SARAYKÖY",
            },
            {
                value: "136",
                text: "SERİNHİSAR",
            },
            {
                value: "137",
                text: "TAVAS",
            },
        ],
    },
    {
        value: "21",
        text: "Diyarbakır",
        hasExpressPickup: false,
        towns: [
            {
                value: "138",
                text: "BAĞLAR",
            },
            {
                value: "139",
                text: "KAYAPINAR",
            },
            {
                value: "140",
                text: "SUR",
            },
            {
                value: "141",
                text: "YENİŞEHİR",
            },
            {
                value: "142",
                text: "BİSMİL",
            },
            {
                value: "143",
                text: "ÇERMİK",
            },
            {
                value: "144",
                text: "ERGANİ",
            },
        ],
    },
    {
        value: "81",
        text: "Düzce",
        hasExpressPickup: false,
        towns: [
            {
                value: "145",
                text: "MERKEZ",
            },
            {
                value: "146",
                text: "AKÇAKOCA",
            },
            {
                value: "147",
                text: "KAYNAŞLI",
            },
        ],
    },
    {
        value: "22",
        text: "Edirne",
        hasExpressPickup: false,
        towns: [
            {
                value: "148",
                text: "ENEZ",
            },
            {
                value: "149",
                text: "HAVSA",
            },
            {
                value: "150",
                text: "İPSALA",
            },
            {
                value: "151",
                text: "KEŞAN",
            },
            {
                value: "152",
                text: "LALAPAŞA",
            },
            {
                value: "153",
                text: "MERİÇ",
            },
            {
                value: "154",
                text: "MERKEZ",
            },
            {
                value: "155",
                text: "SÜLOĞLU",
            },
            {
                value: "156",
                text: "UZUNKÖPRÜ",
            },
        ],
    },
    {
        value: "23",
        text: "Elazığ",
        hasExpressPickup: false,
        towns: [
            {
                value: "157",
                text: "MERKEZ",
            },
            {
                value: "158",
                text: "KARAKOÇAN",
            },
            {
                value: "159",
                text: "KOVANCILAR",
            },
            {
                value: "160",
                text: "PALU",
            },
        ],
    },
    {
        value: "24",
        text: "Erzincan",
        hasExpressPickup: false,
        towns: [
            {
                value: "161",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "25",
        text: "Erzurum",
        hasExpressPickup: false,
        towns: [
            {
                value: "162",
                text: "AZİZİYE",
            },
            {
                value: "163",
                text: "PALANDÖKEN",
            },
            {
                value: "164",
                text: "YAKUTİYE",
            },
        ],
    },
    {
        value: "26",
        text: "Eskişehir",
        hasExpressPickup: false,
        towns: [
            {
                value: "165",
                text: "ODUNPAZARI",
            },
            {
                value: "166",
                text: "TEPEBAŞI",
            },
        ],
    },
    {
        value: "27",
        text: "Gaziantep",
        hasExpressPickup: false,
        towns: [
            {
                value: "167",
                text: "ŞEHİTKAMİL",
            },
            {
                value: "168",
                text: "ŞAHİNBEY",
            },
            {
                value: "169",
                text: "NİZİP",
            },
            {
                value: "170",
                text: "OĞUZELİ",
            },
        ],
    },
    {
        value: "28",
        text: "Giresun",
        hasExpressPickup: false,
        towns: [
            {
                value: "171",
                text: "MERKEZ",
            },
            {
                value: "172",
                text: "BULANCAK",
            },
        ],
    },
    {
        value: "29",
        text: "Gümüşhane",
        hasExpressPickup: false,
        towns: [
            {
                value: "173",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "30",
        text: "Hakkari",
        hasExpressPickup: false,
        towns: [
            {
                value: "174",
                text: "MERKEZ",
            },
            {
                value: "175",
                text: "YÜKSEKOVA",
            },
        ],
    },
    {
        value: "31",
        text: "Hatay",
        hasExpressPickup: false,
        towns: [
            {
                value: "176",
                text: "ANTAKYA",
            },
            {
                value: "177",
                text: "DEFNE",
            },
            {
                value: "178",
                text: "İSKENDERUN",
            },
            {
                value: "179",
                text: "BELEN",
            },
            {
                value: "180",
                text: "DÖRTYOL",
            },
            {
                value: "181",
                text: "PAYAS",
            },
            {
                value: "182",
                text: "ALTINÖZÜ",
            },
            {
                value: "183",
                text: "ARSUZ",
            },
            {
                value: "184",
                text: "ERZİN",
            },
            {
                value: "185",
                text: "HASSA",
            },
            {
                value: "186",
                text: "KIRIKHAN",
            },
            {
                value: "187",
                text: "REYHANLI",
            },
            {
                value: "188",
                text: "SAMANDAĞ",
            },
        ],
    },
    {
        value: "76",
        text: "Iğdır",
        hasExpressPickup: false,
        towns: [
            {
                value: "189",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "32",
        text: "Isparta",
        hasExpressPickup: false,
        towns: [
            {
                value: "190",
                text: "MERKEZ",
            },
            {
                value: "191",
                text: "KEÇİBORLU",
            },
            {
                value: "192",
                text: "YALVAÇ",
            },
        ],
    },
    {
        value: "33",
        text: "İçel",
        hasExpressPickup: false,
        towns: [
            {
                value: "193",
                text: "AKDENİZ",
            },
            {
                value: "194",
                text: "ERDEMLİ",
            },
            {
                value: "195",
                text: "MEZİTLİ",
            },
            {
                value: "196",
                text: "MUT",
            },
            {
                value: "197",
                text: "SİLİFKE",
            },
            {
                value: "198",
                text: "TARSUS",
            },
            {
                value: "199",
                text: "TOROSLAR",
            },
            {
                value: "200",
                text: "YENİŞEHİR",
            },
        ],
    },
    {
        value: "34.2",
        text: "Istanbul Anadolu",
        hasExpressPickup: true,
        towns: [
            {
                value: "201",
                text: "ADALAR",
            },
            {
                value: "202",
                text: "BAKIRKÖY",
            },
            {
                value: "203",
                text: "BEŞİKTAŞ",
            },
            {
                value: "204",
                text: "BEYKOZ",
            },
            {
                value: "205",
                text: "BEYOĞLU",
            },
            {
                value: "206",
                text: "ÇATALCA",
            },
            {
                value: "207",
                text: "EMİNÖNÜ",
            },
            {
                value: "208",
                text: "EYÜPSULTAN",
            },
            {
                value: "209",
                text: "FATİH",
            },
            {
                value: "210",
                text: "GAZİOSMANPAŞA",
            },
            {
                value: "211",
                text: "KADIKÖY",
            },
            {
                value: "212",
                text: "KARTAL",
            },
            {
                value: "213",
                text: "SARIYER",
            },
            {
                value: "214",
                text: "SİLİVRİ",
            },
            {
                value: "215",
                text: "ŞİLE",
            },
            {
                value: "216",
                text: "ŞİŞLİ",
            },
            {
                value: "217",
                text: "ÜSKÜDAR",
            },
            {
                value: "218",
                text: "ZEYTİNBURNU",
            },
            {
                value: "219",
                text: "BÜYÜKÇEKMECE",
            },
            {
                value: "220",
                text: "KAĞITHANE",
            },
            {
                value: "221",
                text: "KÜÇÜKÇEKMECE",
            },
            {
                value: "222",
                text: "PENDİK",
            },
            {
                value: "223",
                text: "ÜMRANİYE",
            },
            {
                value: "224",
                text: "BAYRAMPAŞA",
            },
            {
                value: "225",
                text: "AVCILAR",
            },
            {
                value: "226",
                text: "BAĞCILAR",
            },
            {
                value: "227",
                text: "BAHÇELİEVLER",
            },
            {
                value: "228",
                text: "GÜNGÖREN",
            },
            {
                value: "229",
                text: "MALTEPE",
            },
            {
                value: "230",
                text: "SULTANBEYLİ",
            },
            {
                value: "231",
                text: "TUZLA",
            },
            {
                value: "232",
                text: "ESENLER",
            },
            {
                value: "233",
                text: "ARNAVUTKÖY",
            },
            {
                value: "234",
                text: "ATAŞEHİR",
            },
            {
                value: "235",
                text: "BAHÇEŞEHİR",
            },
            {
                value: "236",
                text: "BAŞAKŞEHİR",
            },
            {
                value: "237",
                text: "BEYLİKDÜZÜ",
            },
            {
                value: "238",
                text: "ÇEKMEKÖY",
            },
            {
                value: "239",
                text: "ESENYURT",
            },
            {
                value: "240",
                text: "SANCAKTEPE",
            },
            {
                value: "241",
                text: "SULTANGAZİ",
            },
            {
                value: "242",
                text: "TESTGECİCİ",
            },
        ],
    },
    {
        value: "34.1",
        text: "Istanbul Avrupa",
        hasExpressPickup: true,
        towns: [
            {
                value: "243",
                text: "ADALAR",
            },
            {
                value: "244",
                text: "BAKIRKÖY",
            },
            {
                value: "245",
                text: "BEŞİKTAŞ",
            },
            {
                value: "246",
                text: "BEYKOZ",
            },
            {
                value: "247",
                text: "BEYOĞLU",
            },
            {
                value: "248",
                text: "ÇATALCA",
            },
            {
                value: "249",
                text: "EMİNÖNÜ",
            },
            {
                value: "250",
                text: "EYÜPSULTAN",
            },
            {
                value: "251",
                text: "FATİH",
            },
            {
                value: "252",
                text: "GAZİOSMANPAŞA",
            },
            {
                value: "253",
                text: "KADIKÖY",
            },
            {
                value: "254",
                text: "KARTAL",
            },
            {
                value: "255",
                text: "SARIYER",
            },
            {
                value: "256",
                text: "SİLİVRİ",
            },
            {
                value: "257",
                text: "ŞİLE",
            },
            {
                value: "258",
                text: "ŞİŞLİ",
            },
            {
                value: "259",
                text: "ÜSKÜDAR",
            },
            {
                value: "260",
                text: "ZEYTİNBURNU",
            },
            {
                value: "261",
                text: "BÜYÜKÇEKMECE",
            },
            {
                value: "262",
                text: "KAĞITHANE",
            },
            {
                value: "263",
                text: "KÜÇÜKÇEKMECE",
            },
            {
                value: "264",
                text: "PENDİK",
            },
            {
                value: "265",
                text: "ÜMRANİYE",
            },
            {
                value: "266",
                text: "BAYRAMPAŞA",
            },
            {
                value: "267",
                text: "AVCILAR",
            },
            {
                value: "268",
                text: "BAĞCILAR",
            },
            {
                value: "269",
                text: "BAHÇELİEVLER",
            },
            {
                value: "270",
                text: "GÜNGÖREN",
            },
            {
                value: "271",
                text: "MALTEPE",
            },
            {
                value: "272",
                text: "SULTANBEYLİ",
            },
            {
                value: "273",
                text: "TUZLA",
            },
            {
                value: "274",
                text: "ESENLER",
            },
            {
                value: "275",
                text: "ARNAVUTKÖY",
            },
            {
                value: "276",
                text: "ATAŞEHİR",
            },
            {
                value: "277",
                text: "BAHÇEŞEHİR",
            },
            {
                value: "278",
                text: "BAŞAKŞEHİR",
            },
            {
                value: "279",
                text: "BEYLİKDÜZÜ",
            },
            {
                value: "280",
                text: "ÇEKMEKÖY",
            },
            {
                value: "281",
                text: "ESENYURT",
            },
            {
                value: "282",
                text: "SANCAKTEPE",
            },
            {
                value: "283",
                text: "SULTANGAZİ",
            },
            {
                value: "284",
                text: "TESTGECİCİ",
            },
        ],
    },
    {
        value: "35",
        text: "İzmir",
        hasExpressPickup: false,
        towns: [
            {
                value: "285",
                text: "ALİAĞA",
            },
            {
                value: "286",
                text: "BALÇOVA",
            },
            {
                value: "287",
                text: "BAYINDIR",
            },
            {
                value: "288",
                text: "BAYRAKLI",
            },
            {
                value: "289",
                text: "BERGAMA",
            },
            {
                value: "290",
                text: "BEYDAĞ",
            },
            {
                value: "291",
                text: "BUCA",
            },
            {
                value: "292",
                text: "ÇEŞME",
            },
            {
                value: "293",
                text: "ÇİĞLİ",
            },
            {
                value: "294",
                text: "DİKİLİ",
            },
            {
                value: "295",
                text: "FOÇA",
            },
            {
                value: "296",
                text: "GAZİEMİR",
            },
            {
                value: "297",
                text: "GÜZELBAHÇE",
            },
            {
                value: "298",
                text: "KARABAĞLAR",
            },
            {
                value: "299",
                text: "KARABURUN",
            },
            {
                value: "300",
                text: "KARŞIYAKA",
            },
            {
                value: "301",
                text: "KEMALPAŞA",
            },
            {
                value: "302",
                text: "KİRAZ",
            },
            {
                value: "303",
                text: "KONAK",
            },
            {
                value: "304",
                text: "MENDERES",
            },
            {
                value: "305",
                text: "MENEMEN",
            },
            {
                value: "306",
                text: "NARLIDERE",
            },
            {
                value: "307",
                text: "ÖDEMİŞ",
            },
            {
                value: "308",
                text: "SEFERİHİSAR",
            },
            {
                value: "309",
                text: "SELÇUK",
            },
            {
                value: "310",
                text: "TİRE",
            },
            {
                value: "311",
                text: "TORBALI",
            },
            {
                value: "312",
                text: "URLA",
            },
        ],
    },
    {
        value: "46",
        text: "Kahramanmaraş",
        hasExpressPickup: false,
        towns: [
            {
                value: "313",
                text: "DULKADİROĞLU",
            },
            {
                value: "314",
                text: "ONİKİŞUBAT",
            },
            {
                value: "315",
                text: "PAZARCIK",
            },
        ],
    },
    {
        value: "78",
        text: "Karabük",
        hasExpressPickup: false,
        towns: [
            {
                value: "316",
                text: "MERKEZ",
            },
            {
                value: "317",
                text: "SAFRANBOLU",
            },
        ],
    },
    {
        value: "70",
        text: "Karaman",
        hasExpressPickup: false,
        towns: [
            {
                value: "318",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "36",
        text: "Kars",
        hasExpressPickup: false,
        towns: [
            {
                value: "319",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "37",
        text: "Kastamonu",
        hasExpressPickup: false,
        towns: [
            {
                value: "320",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "38",
        text: "Kayseri",
        hasExpressPickup: false,
        towns: [
            {
                value: "321",
                text: "KOCASİNAN",
            },
            {
                value: "322",
                text: "TALAS",
            },
        ],
    },
    {
        value: "71",
        text: "Kırıkkale",
        hasExpressPickup: false,
        towns: [
            {
                value: "323",
                text: "MERKEZ",
            },
            {
                value: "324",
                text: "BAHŞILI",
            },
            {
                value: "325",
                text: "YAHŞİHAN",
            },
        ],
    },
    {
        value: "39",
        text: "Kırklareli",
        hasExpressPickup: false,
        towns: [
            {
                value: "326",
                text: "LÜLEBURGAZ",
            },
            {
                value: "327",
                text: "PINARHİSAR",
            },
            {
                value: "328",
                text: "BABAESKİ",
            },
            {
                value: "329",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "40",
        text: "Kırşehir",
        hasExpressPickup: false,
        towns: [
            {
                value: "330",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "79",
        text: "Kilis",
        hasExpressPickup: false,
        towns: [
            {
                value: "331",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "41",
        text: "Kocaeli",
        hasExpressPickup: false,
        towns: [
            {
                value: "332",
                text: "GÖLCÜK",
            },
            {
                value: "333",
                text: "KANDIRA",
            },
            {
                value: "334",
                text: "KARAMÜRSEL",
            },
            {
                value: "335",
                text: "KÖRFEZ",
            },
            {
                value: "336",
                text: "DERİNCE",
            },
            {
                value: "337",
                text: "BAŞİSKELE",
            },
            {
                value: "338",
                text: "İZMİT",
            },
            {
                value: "339",
                text: "KARTEPE",
            },
            {
                value: "340",
                text: "GEBZE",
            },
            {
                value: "341",
                text: "DARICA",
            },
            {
                value: "342",
                text: "ÇAYIROVA",
            },
            {
                value: "343",
                text: "DİLOVASI",
            },
        ],
    },
    {
        value: "42",
        text: "Konya",
        hasExpressPickup: false,
        towns: [
            {
                value: "344",
                text: "AKŞEHİR",
            },
            {
                value: "345",
                text: "KARATAY",
            },
            {
                value: "346",
                text: "MERAM",
            },
            {
                value: "347",
                text: "SELÇUKLU",
            },
        ],
    },
    {
        value: "43",
        text: "Kütahya",
        hasExpressPickup: false,
        towns: [
            {
                value: "348",
                text: "MERKEZ",
            },
            {
                value: "349",
                text: "TAVŞANLI",
            },
        ],
    },
    {
        value: "44",
        text: "Malatya",
        hasExpressPickup: false,
        towns: [
            {
                value: "350",
                text: "BATTALGAZİ",
            },
            {
                value: "351",
                text: "YEŞİLYURT",
            },
        ],
    },
    {
        value: "45",
        text: "Manisa",
        hasExpressPickup: false,
        towns: [
            {
                value: "352",
                text: "AKHİSAR",
            },
            {
                value: "353",
                text: "ALAŞEHİR",
            },
            {
                value: "354",
                text: "KULA",
            },
            {
                value: "355",
                text: "SALİHLİ",
            },
            {
                value: "356",
                text: "SARUHANLI",
            },
            {
                value: "357",
                text: "SOMA",
            },
            {
                value: "358",
                text: "TURGUTLU",
            },
            {
                value: "359",
                text: "ŞEHZADELER",
            },
            {
                value: "360",
                text: "YUNUSEMRE",
            },
            {
                value: "361",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "47",
        text: "Mardin",
        hasExpressPickup: false,
        towns: [
            {
                value: "362",
                text: "KIZILTEPE",
            },
            {
                value: "363",
                text: "ARTUKLU",
            },
            {
                value: "364",
                text: "MİDYAT",
            },
            {
                value: "365",
                text: "NUSAYBİN",
            },
        ],
    },
    {
        value: "48",
        text: "Muğla",
        hasExpressPickup: false,
        towns: [
            {
                value: "366",
                text: "BODRUM",
            },
            {
                value: "367",
                text: "FETHİYE",
            },
            {
                value: "368",
                text: "DALAMAN",
            },
            {
                value: "369",
                text: "MENTEŞE",
            },
            {
                value: "370",
                text: "ORTACA",
            },
            {
                value: "371",
                text: "SEYDİKEMER",
            },
            {
                value: "372",
                text: "MARMARİS",
            },
            {
                value: "373",
                text: "KÖYCEĞİZ",
            },
            {
                value: "374",
                text: "YATAĞAN",
            },
            {
                value: "375",
                text: "ULA",
            },
            {
                value: "376",
                text: "MİLAS",
            },
            {
                value: "377",
                text: "DATÇA",
            },
        ],
    },
    {
        value: "49",
        text: "Muş",
        hasExpressPickup: false,
        towns: [
            {
                value: "378",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "50",
        text: "Nevşehir",
        hasExpressPickup: false,
        towns: [
            {
                value: "379",
                text: "MERKEZ",
            },
            {
                value: "380",
                text: "ACIGÖL",
            },
            {
                value: "381",
                text: "AVANOS",
            },
            {
                value: "382",
                text: "ÜRGÜP",
            },
        ],
    },
    {
        value: "51",
        text: "Niğde",
        hasExpressPickup: false,
        towns: [
            {
                value: "383",
                text: "BOR",
            },
            {
                value: "384",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "52",
        text: "Ordu",
        hasExpressPickup: false,
        towns: [
            {
                value: "385",
                text: "ALTINORDU",
            },
            {
                value: "386",
                text: "ÜNYE",
            },
            {
                value: "387",
                text: "FATSA",
            },
        ],
    },
    {
        value: "80",
        text: "Osmaniye",
        hasExpressPickup: false,
        towns: [
            {
                value: "388",
                text: "MERKEZ",
            },
            {
                value: "389",
                text: "TOPRAKKALE",
            },
            {
                value: "390",
                text: "BAHÇE",
            },
            {
                value: "391",
                text: "DÜZİÇİ",
            },
            {
                value: "392",
                text: "HASANBEYLİ",
            },
            {
                value: "393",
                text: "KADİRLİ",
            },
        ],
    },
    {
        value: "53",
        text: "Rize",
        hasExpressPickup: false,
        towns: [
            {
                value: "394",
                text: "MERKEZ",
            },
            {
                value: "395",
                text: "ARDEŞEN",
            },
            {
                value: "396",
                text: "ÇAYELİ",
            },
            {
                value: "397",
                text: "PAZAR",
            },
        ],
    },
    {
        value: "54",
        text: "Sakarya",
        hasExpressPickup: false,
        towns: [
            {
                value: "398",
                text: "ADAPAZARI",
            },
            {
                value: "399",
                text: "AKYAZI",
            },
            {
                value: "400",
                text: "ARİFİYE",
            },
            {
                value: "401",
                text: "ERENLER",
            },
            {
                value: "402",
                text: "FERİZLİ",
            },
            {
                value: "403",
                text: "GEYVE",
            },
            {
                value: "404",
                text: "HENDEK",
            },
            {
                value: "405",
                text: "KARAPÜRÇEK",
            },
            {
                value: "406",
                text: "KARASU",
            },
            {
                value: "407",
                text: "KAYNARCA",
            },
            {
                value: "408",
                text: "PAMUKOVA",
            },
            {
                value: "409",
                text: "SAPANCA",
            },
            {
                value: "410",
                text: "SERDİVAN",
            },
            {
                value: "411",
                text: "SÖĞÜTLÜ",
            },
        ],
    },
    {
        value: "55",
        text: "Samsun",
        hasExpressPickup: false,
        towns: [
            {
                value: "412",
                text: "19 MAYIS",
            },
            {
                value: "413",
                text: "ATAKUM",
            },
            {
                value: "414",
                text: "BAFRA",
            },
            {
                value: "415",
                text: "CANİK",
            },
            {
                value: "416",
                text: "ÇARŞAMBA",
            },
            {
                value: "417",
                text: "HAVZA",
            },
            {
                value: "418",
                text: "İLKADIM",
            },
            {
                value: "419",
                text: "TEKKEKÖY",
            },
            {
                value: "420",
                text: "TERME",
            },
            {
                value: "421",
                text: "VEZİRKÖPRÜ",
            },
        ],
    },
    {
        value: "56",
        text: "Siirt",
        hasExpressPickup: false,
        towns: [
            {
                value: "422",
                text: "KURTALAN",
            },
            {
                value: "423",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "57",
        text: "Sinop",
        hasExpressPickup: false,
        towns: [
            {
                value: "424",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "58",
        text: "Sivas",
        hasExpressPickup: false,
        towns: [
            {
                value: "425",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "63",
        text: "Şanlıurfa",
        hasExpressPickup: false,
        towns: [
            {
                value: "426",
                text: "EYYÜBİYE",
            },
            {
                value: "427",
                text: "HALİLİYE",
            },
            {
                value: "428",
                text: "KARAKÖPRÜ",
            },
            {
                value: "429",
                text: "BİRECİK",
            },
            {
                value: "430",
                text: "CEYLANPINAR",
            },
            {
                value: "431",
                text: "HİLVAN",
            },
            {
                value: "432",
                text: "SİVEREK",
            },
            {
                value: "433",
                text: "SURUÇ",
            },
            {
                value: "434",
                text: "VİRANŞEHİR",
            },
        ],
    },
    {
        value: "73",
        text: "Şırnak",
        hasExpressPickup: false,
        towns: [
            {
                value: "435",
                text: "CİZRE",
            },
            {
                value: "436",
                text: "MERKEZ",
            },
            {
                value: "437",
                text: "SİLOPİ",
            },
        ],
    },
    {
        value: "59",
        text: "Tekirdağ",
        hasExpressPickup: false,
        towns: [
            {
                value: "438",
                text: "ÇERKEZKÖY",
            },
            {
                value: "439",
                text: "ÇORLU",
            },
            {
                value: "440",
                text: "ERGENE",
            },
            {
                value: "441",
                text: "KAPAKLI",
            },
            {
                value: "442",
                text: "MALKARA",
            },
            {
                value: "443",
                text: "MARMARAEREĞLİSİ",
            },
            {
                value: "444",
                text: "MURATLI",
            },
            {
                value: "445",
                text: "SARAY",
            },
            {
                value: "446",
                text: "SÜLEYMANPAŞA",
            },
            {
                value: "447",
                text: "ŞARKÖY",
            },
        ],
    },
    {
        value: "60",
        text: "Tokat",
        hasExpressPickup: false,
        towns: [
            {
                value: "448",
                text: "MERKEZ",
            },
            {
                value: "449",
                text: "TURHAL",
            },
            {
                value: "450",
                text: "ERBAA",
            },
            {
                value: "451",
                text: "NİKSAR",
            },
            {
                value: "452",
                text: "ZİLE",
            },
        ],
    },
    {
        value: "61",
        text: "Trabzon",
        hasExpressPickup: false,
        towns: [
            {
                value: "453",
                text: "AKÇAABAT",
            },
            {
                value: "454",
                text: "OF",
            },
            {
                value: "455",
                text: "ORTAHİSAR",
            },
            {
                value: "456",
                text: "YOMRA",
            },
        ],
    },
    {
        value: "62",
        text: "Tunceli",
        hasExpressPickup: false,
        towns: [
            {
                value: "457",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "64",
        text: "Uşak",
        hasExpressPickup: false,
        towns: [
            {
                value: "458",
                text: "MERKEZ",
            },
        ],
    },
    {
        value: "65",
        text: "Van",
        hasExpressPickup: false,
        towns: [
            {
                value: "459",
                text: "EDREMİT",
            },
            {
                value: "460",
                text: "İPEKYOLU",
            },
            {
                value: "461",
                text: "TUŞBA",
            },
        ],
    },
    {
        value: "77",
        text: "Yalova",
        hasExpressPickup: false,
        towns: [
            {
                value: "462",
                text: "MERKEZ",
            },
            {
                value: "463",
                text: "ÇİFTLİKKÖY",
            },
            {
                value: "464",
                text: "ALTINOVA",
            },
            {
                value: "465",
                text: "TERMAL",
            },
            {
                value: "466",
                text: "ÇINARCIK",
            },
        ],
    },
    {
        value: "66",
        text: "Yozgat",
        hasExpressPickup: false,
        towns: [
            {
                value: "467",
                text: "MERKEZ",
            },
            {
                value: "468",
                text: "SORGUN",
            },
            {
                value: "469",
                text: "YERKÖY",
            },
        ],
    },
    {
        value: "67",
        text: "Zonguldak",
        hasExpressPickup: false,
        towns: [
            {
                value: "470",
                text: "KOZLU",
            },
            {
                value: "471",
                text: "MERKEZ",
            },
            {
                value: "472",
                text: "ALAPLI",
            },
            {
                value: "473",
                text: "ÇAYCUMA",
            },
            {
                value: "474",
                text: "DEVREK",
            },
            {
                value: "475",
                text: "EREĞLİ",
            },
            {
                value: "476",
                text: "KİLİMLİ",
            },
        ],
    },
];

// export const senderCities = [
//     {
//         value:"01",
//         text: "Adana",
//         hasExpressPickup: false,
//     },
//     {
//         value:"02",
//         text: "Adıyaman",
//         hasExpressPickup: false,
//     },
//     {
//         value:"03",
//         text: "Afyon",
//         hasExpressPickup: false,
//     },
//     {
//         value:"04",
//         text: "Ağrı",
//         hasExpressPickup: false,
//     },
//     {
//         value:"68",
//         text: "Aksaray",
//         hasExpressPickup: false,
//     },
//     {
//         value:"05",
//         text: "Amasya",
//         hasExpressPickup: false,
//     },
//     {
//         value:"06",
//         text: "Ankara",
//         hasExpressPickup: false,
//     },
//     {
//         value:"07",
//         text: "Antalya",
//         senderRegion: "Анталья",
//         hasExpressPickup: true,
//     },
//     {
//         value:"75",
//         text: "Ardahan",
//         hasExpressPickup: false,
//     },
//     {
//         value:"08",
//         text: "Artvin",
//         hasExpressPickup: false,
//     },
//     {
//         value:"09",
//         text: "Aydın",
//         hasExpressPickup: false,
//     },
//     {
//         value:"10",
//         text: "Balıkesir",
//         hasExpressPickup: false,
//     },
//     {
//         value:"74",
//         text: "Bartın",
//         hasExpressPickup: false,
//     },
//     {
//         value:"72",
//         text: "Batman",
//         hasExpressPickup: false,
//     },
//     {
//         value:"69",
//         text: "Bayburt",
//         hasExpressPickup: false,
//     },
//     {
//         value:"11",
//         text: "Bilecik",
//         hasExpressPickup: false,
//     },
//     {
//         value:"12",
//         text: "Bingöl",
//         hasExpressPickup: false,
//     },
//     {
//         value:"13",
//         text: "Bitlis",
//         hasExpressPickup: false,
//     },
//     {
//         value:"14",
//         text: "Bolu",
//         hasExpressPickup: false,
//     },
//     {
//         value:"15",
//         text: "Burdur",
//         hasExpressPickup: false,
//     },
//     {
//         value:"16",
//         text: "Bursa",
//         hasExpressPickup: false,
//     },
//     {
//         value:"17",
//         text: "Çanakkale",
//         hasExpressPickup: false,
//     },
//     {
//         value:"18",
//         text: "Çankırı",
//         hasExpressPickup: false,
//     },
//     {
//         value:"19",
//         text: "Çorum",
//         hasExpressPickup: false,
//     },
//     {
//         value:"20",
//         text: "Denizli",
//         hasExpressPickup: false,
//     },
//     {
//         value:"21",
//         text: "Diyarbakır",
//         hasExpressPickup: false,
//     },
//     {
//         value:"81",
//         text: "Düzce",
//         hasExpressPickup: false,
//     },
//     {
//         value:"22",
//         text: "Edirne",
//         hasExpressPickup: false,
//     },
//     {
//         value:"23",
//         text: "Elazığ",
//         hasExpressPickup: false,
//     },
//     {
//         value:"24",
//         text: "Erzincan",
//         hasExpressPickup: false,
//     },
//     {
//         value:"25",
//         text: "Erzurum",
//         hasExpressPickup: false,
//     },
//     {
//         value:"26",
//         text: "Eskişehir",
//         hasExpressPickup: false,
//     },
//     {
//         value:"27",
//         text: "Gaziantep",
//         hasExpressPickup: false,
//     },
//     {
//         value:"28",
//         text: "Giresun",
//         hasExpressPickup: false,
//     },
//     {
//         value:"29",
//         text: "Gümüşhane",
//         hasExpressPickup: false,
//     },
//     {
//         value:"30",
//         text: "Hakkari",
//         hasExpressPickup: false,
//     },
//     {
//         value:"31",
//         text: "Hatay",
//         hasExpressPickup: false,
//     },
//     {
//         value:"76",
//         text: "Iğdır",
//         hasExpressPickup: false,
//     },
//     {
//         value:"32",
//         text: "Isparta",
//         hasExpressPickup: false,
//     },
//     {
//         value:"33",
//         text: "İçel",
//         hasExpressPickup: false,
//     },
//     {
//         value:"34.2",
//         text: "Istanbul Anadolu",
//         senderRegion: "Азиатская часть Стамбула",
//         hasExpressPickup: true,
//     },
//     {
//         value:"34.1",
//         text: "Istanbul Avrupa",
//         senderRegion: "Европейская часть Стамбула",
//         hasExpressPickup: true,
//     },
//     {
//         value:"35",
//         text: "İzmir",
//         hasExpressPickup: false,
//     },
//     {
//         value:"46",
//         text: "Kahramanmaraş",
//         hasExpressPickup: false,
//     },
//     {
//         value:"78",
//         text: "Karabük",
//         hasExpressPickup: false,
//     },
//     {
//         value:"70",
//         text: "Karaman",
//         hasExpressPickup: false,
//     },
//     {
//         value:"36",
//         text: "Kars",
//         hasExpressPickup: false,
//     },
//     {
//         value:"37",
//         text: "Kastamonu",
//         hasExpressPickup: false,
//     },
//     {
//         value:"38",
//         text: "Kayseri",
//         hasExpressPickup: false,
//     },
//     {
//         value:"71",
//         text: "Kırıkkale",
//         hasExpressPickup: false,
//     },
//     {
//         value:"39",
//         text: "Kırklareli",
//         hasExpressPickup: false,
//     },
//     {
//         value:"40",
//         text: "Kırşehir",
//         hasExpressPickup: false,
//     },
//     {
//         value:"79",
//         text: "Kilis",
//         hasExpressPickup: false,
//     },
//     {
//         value:"41",
//         text: "Kocaeli",
//         hasExpressPickup: false,
//     },
//     {
//         value:"42",
//         text: "Konya",
//         hasExpressPickup: false,
//     },
//     {
//         value:"43",
//         text: "Kütahya",
//         hasExpressPickup: false,
//     },
//     {
//         value:"44",
//         text: "Malatya",
//         hasExpressPickup: false,
//     },
//     {
//         value:"45",
//         text: "Manisa",
//         hasExpressPickup: false,
//     },
//     {
//         value:"47",
//         text: "Mardin",
//         hasExpressPickup: false,
//     },
//     {
//         value:"48",
//         text: "Muğla",
//         hasExpressPickup: false,
//     },
//     {
//         value:"49",
//         text: "Muş",
//         hasExpressPickup: false,
//     },
//     {
//         value:"50",
//         text: "Nevşehir",
//         hasExpressPickup: false,
//     },
//     {
//         value:"51",
//         text: "Niğde",
//         hasExpressPickup: false,
//     },
//     {
//         value:"52",
//         text: "Ordu",
//         hasExpressPickup: false,
//     },
//     {
//         value:"80",
//         text: "Osmaniye",
//         hasExpressPickup: false,
//     },
//     {
//         value:"53",
//         text: "Rize",
//         hasExpressPickup: false,
//     },
//     {
//         value:"54",
//         text: "Sakarya",
//         hasExpressPickup: false,
//     },
//     {
//         value:"55",
//         text: "Samsun",
//         hasExpressPickup: false,
//     },
//     {
//         value:"56",
//         text: "Siirt",
//         hasExpressPickup: false,
//     },
//     {
//         value:"57",
//         text: "Sinop",
//         hasExpressPickup: false,
//     },
//     {
//         value:"58",
//         text: "Sivas",
//         hasExpressPickup: false,
//     },
//     {
//         value:"63",
//         text: "Şanlıurfa",
//         hasExpressPickup: false,
//     },
//     {
//         value:"73",
//         text: "Şırnak",
//         hasExpressPickup: false,
//     },
//     {
//         value:"59",
//         text: "Tekirdağ",
//         hasExpressPickup: false,
//     },
//     {
//         value:"60",
//         text: "Tokat",
//         hasExpressPickup: false,
//     },
//     {
//         value:"61",
//         text: "Trabzon",
//         hasExpressPickup: false,
//     },
//     {
//         value:"62",
//         text: "Tunceli",
//         hasExpressPickup: false,
//     },
//     {
//         value:"64",
//         text: "Uşak",
//         hasExpressPickup: false,
//     },
//     {
//         value:"65",
//         text: "Van",
//         hasExpressPickup: false,
//     },
//     {
//         value:"77",
//         text: "Yalova",
//         hasExpressPickup: false,
//     },
//     {
//         value:"66",
//         text: "Yozgat",
//         hasExpressPickup: false,
//     },
//     {
//         value:"67",
//         text: "Zonguldak",
//         hasExpressPickup: false,
//     },
// ];
